import { Component, OnInit } from '@angular/core';
import Swal from "sweetalert2";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {map, Observable, startWith} from 'rxjs';
import {MatTableDataSource} from "@angular/material/table";
import {AlmacenService} from "../../services/api/almacen.service";
import {FormIngresoService} from "../../services/forms/form-ingreso.service";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DialogIngresoAventuraComponent} from "./dialog-ingreso-aventura/dialog-ingreso-aventura.component";
import { AventuraService } from 'src/app/services/api/aventura.service';

@Component({
  selector: 'app-ingreso',
  templateUrl: './ingreso.component.html',
  styleUrls: ['./ingreso.component.css']
})
export class IngresoComponent implements OnInit {

  ingresoForm!:FormGroup;
  displayedColumns = ['nombre','marca','modelo','valoracion','observaciones','cantidad','costo','modificar','eliminar'];

  addedIngreso: any[]=[

  ];


  myControl = new FormControl<string | any>('');
  proveedorControl = new FormControl<string | any>('');

  equipos: any=[];
  proveedores: any=[];
  filteredOptions!: Observable<any[]>;
  filteredOptionsProveedor!: Observable<any[]>;

  ubicacionControl = new FormControl('');
  ubicaciones: string[] = ['Cuzco', 'Huaraz','Lima'];

  dataSource = new MatTableDataSource(this.addedIngreso);

  constructor(private fb: FormBuilder,private aventuraService:AventuraService,private almacenService:AlmacenService, private formIngresoService:FormIngresoService,public dialog:MatDialog) {

  }

  ngOnInit(): void {

    this.ingresoForm = this.fb.group({
      ingreso: this.formIngresoService.getIngresoEquipoForm()
    });
    console.log(this.ingresoForm);

    this.getAllEquipos();
    this.getAllProveedores();

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : value?.nombre;
        return nombre ? this._filter(nombre as string) : this.equipos.slice();
      }),
    );


    this.filteredOptionsProveedor = this.proveedorControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : value?.nombre;
        return nombre ? this._filterProveedor(nombre as string) : this.proveedores.slice();
      }),
    );

  }

  getAllEquipos(): any[]{
    this.aventuraService.getAllEquiposInventario().subscribe((response: {})=>{
      this.equipos=response;
      console.log(response)
      return response;
    });
    return this.equipos
  }

  getAllProveedores(): any[]{
    this.almacenService.getAllProveedores().subscribe((response: {})=>{
      this.proveedores=response;
      console.log(response)
    });
    return this.proveedores
  }

  private _filter(nombre: string): any[] {
    const filterValue = nombre.toLowerCase();

    return this.equipos.filter((option: { nombre: string; }) => option.nombre.toLowerCase().includes(filterValue));
  }

  private _filterProveedor(nombre: string): any[] {
    const filterValue = nombre.toLowerCase();

    return this.proveedores.filter((proveedor: { nombre: string; }) => proveedor.nombre.toLowerCase().includes(filterValue));
  }

  addElement() {
    var element = {
      nombre: this.myControl.value.nombre,
      marca: this.myControl.value.marca,
      modelo: this.myControl.value.modelo,

      valoracion:this.ingresoForm.value.ingreso.equipoAlmacen.valoracion,
      observaciones:this.ingresoForm.value.ingreso.equipoAlmacen.observaciones,
      cantidad:this.ingresoForm.value.ingreso.equipoAlmacen.cantidad,
      costo: this.ingresoForm.value.ingreso.equipoAlmacen.costo,
    };

    this.addedIngreso.push(element);
    console.log(this.ingresoForm);
    // console.log(this.formGroup.value.insumo.nombre);
    // console.log(this.myControl.value.nombre);
    this.dataSource = new MatTableDataSource(this.addedIngreso);
  }

  getOptionText(option: any) {
    return option.nombre;
  }

  deleteRegistro(i:number): void {

    Swal.fire({
      title: 'Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          'Eliminado',
          'El registro se eliminó satisfactoriamente.',
          'success'
        )
        this.dataSource.data.splice(i, 1);
        this.dataSource._updateChangeSubscription();
      }
      else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("false");
      }
    })


  }

  openDialogModify(i:number): void {

    let dialogConfig=new MatDialogConfig();
    dialogConfig.data={
      valoracion:this.addedIngreso[i].valoracion,
      observaciones:this.addedIngreso[i].observaciones,
      cantidad:this.addedIngreso[i].cantidad,
      costo:this.addedIngreso[i].costo,
      title:"Modificar"
    };
    dialogConfig.width="50%";

    let dialogRef = this.dialog.open(DialogIngresoAventuraComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
